import {apiClient} from '@/services/base/BaseService';

export async function getListShopCollection(organizationId: number, shopId: number) {
    const url = `organizations/${organizationId}/shops/${shopId}/shop-collections`;
    const response = await apiClient.get(url);
    return response.data.data;
}

